import { getClient } from "../config";

const CLIENTS_WITH_INTEGRATED_LOGIN = [
  {
    clientName: "TEMPLATE",
    link: "https://api.cadernovirtual.com.br/auth-piracanjuba/dologin.jsp?perfil=Aluno",
  },
  {
    clientName: "PIRACANJUBA",
    link: "https://api.cadernovirtual.com.br/auth-piracanjuba/dologin.jsp?perfil=Aluno",
  },
];

export const CLIENT_HAS_INTEGRATED_LOGIN = () =>
  CLIENTS_WITH_INTEGRATED_LOGIN.some((obj) => {
    return obj.clientName === getClient().toUpperCase();
  });

export const CLIENT_INTEGRATED_LOGIN_LINK = () =>
  CLIENTS_WITH_INTEGRATED_LOGIN.find(
    (obj) => obj.clientName === getClient().toUpperCase()
  ).link;
